import React, { useState } from "react";
import "./Categories.scss";
import ContactCheck from "../../../../images/greenArrow.svg";
import { Progress } from "reactstrap";
import {
  categoryDetailsFCProps,
  Questionstatus,
} from "../../../../models/ClientPortalCategoriesDetails/CategoriesDetails";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RoutesEnum } from "../../../../utils/RoutesUtil";

const CategoryDetailsFC: React.FC<categoryDetailsFCProps> = (
  props: categoryDetailsFCProps
) => {
  const requiredInfo: Questionstatus[] = [];
  const navigate = useNavigate();
  const { clientProductId } = useParams();
  const location = useLocation();
  const completed = (questionStatus: any) => {
    const value = questionStatus.filter(
      (item: Questionstatus) => item.isCompleted === false
    );
    if (value.length === 0) {
      return true;
    }
    return false;
  };
  props?.categoryCard.questionstatus.map(
    (completedQuestionarie: Questionstatus) => {
      if (completedQuestionarie.questionType === "FileUpload") {
        const questionStatusSingleObject: Questionstatus = {
          questionText: completedQuestionarie.questionText,
          isCompleted: completedQuestionarie.isCompleted,
          questionType: completedQuestionarie.questionType,
        };
        requiredInfo.push(questionStatusSingleObject);
      } else {
        const questionStatusSingleObject: Questionstatus = {
          questionText:
            (props.categoryCard.subCategoryName.includes('General') ? "" : "General ") + props.categoryCard.subCategoryName +
            (props.categoryCard.subCategoryName.includes('Information') ? "" : " Information"),
          isCompleted: completed(props?.categoryCard.questionstatus),
          questionType: completedQuestionarie.questionType,
        };
        if (
          !requiredInfo.find(
            (m: any) =>
              questionStatusSingleObject.questionText === m.questionText
          )
        ) {
          requiredInfo.push(questionStatusSingleObject);
        }
      }
    }
  );

  const categoryQuestionarie = () => {
    navigate(`/${RoutesEnum.CLIENT_QUESTIONARIE}/questionarie/${props.screenType}/${clientProductId}/${props.categoryId}/${props?.categoryCard?.questionnarieSubcategoryId}`,
      { state: location.state });
  };

  return (
    <>

      <div className="categoryCard">
        <div className="CategoryCardHeadingContainer">
          <h1 className="CategoryCardHeading">
            {props?.categoryCard?.subCategoryName}
          </h1>
          <button
            className="categoryCardButton"
            onClick={() =>
              categoryQuestionarie()
            }
          >
            View
          </button>
        </div>
        <div className="CompletedForm">
          {props?.categoryCard.questionstatus ? (
            <>
              <p className="questionStatusdesc">Required Information:</p>
              {requiredInfo.map((completedQuestionarie: Questionstatus, index: number) => (
                <div key={index} className="completedFormContainer">
                  <div className="contactCheckContainer">
                    {completedQuestionarie.isCompleted ? (
                      <img src={ContactCheck} alt="contactImg" />
                    ) : (
                      <span className="spacegenerated"></span>
                    )}
                  </div>
                  <p className="questiontext">
                    {completedQuestionarie.questionText}
                  </p>
                </div>
              ))}
            </>
          ) : (
            <p className="questiontext">
              {props?.categoryCard?.subCategoryDescription}
            </p>
          )}
        </div>
        <div className="CategoryCardHeadingContainer">
          {props?.categoryCard?.completedPercentage === 100 && (
            <p className="completedpercentageText">{location.pathname.indexOf("clientQuestionarie/subCategories/clientView") === 1 ?
              "Completed" : "Review Complete"}</p>
          )}
        </div>

        <div className="progressBarContainer">
          <span className="progressPercentage">
            {props?.categoryCard?.completedPercentage}%
          </span>
          {props?.categoryCard?.completedPercentage === 100 ? (
            <Progress
              bar
              color="success"
              className="progressBar"
              value={props?.categoryCard?.completedPercentage}
            />
          ) : (
            <Progress
              className="progressBar"
              value={props?.categoryCard?.completedPercentage}
            />
          )}
        </div>
      </div>
    </>

  );
};

export default CategoryDetailsFC;
